/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

export default function ReviewsSection({ storeReviews, theme }) {
  if (!Array.isArray(storeReviews) || storeReviews.length === 0) return null;

  return (
    <section
      className="border-t py-10"
      style={{
        backgroundColor: "rgba(0,0,0,0.3)",
        borderColor: "rgba(255,255,255,0.1)"
      }}
    >
      <div className="max-w-6xl mx-auto px-4">
        <h3 className="text-xl font-semibold mb-6 text-center text-white">
          ماذا يقول عملاؤنا 💕
        </h3>

        <Swiper
          modules={[Autoplay]}
          autoplay={{
            delay: 3500,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          }}
          loop
          spaceBetween={16}
          breakpoints={{
            0: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 }
          }}
        >
          {storeReviews.map(r => (
            <SwiperSlide key={r.id}>
              <div
                className="border rounded-2xl p-4 h-full"
                style={{
                  backgroundColor: "rgba(0,0,0,0.4)",
                  borderColor: "rgba(255,255,255,0.1)"
                }}
              >
                <div className="flex gap-1 mb-2">
                  {[...Array(5)].map((_, i) => (
                    <span key={i} style={{ color: theme.accent }}>
                      {i < r.rating ? "★" : "☆"}
                    </span>
                  ))}
                </div>

                <p className="text-xs text-white/70 mb-2">
                  "{r.description}"
                </p>

                <div className="flex justify-between text-xs">
                  <span style={{ color: theme.accent }}>
                    {r.customerName || "عميل"}
                  </span>
                  <span className="text-white/50">
                    {new Date(r.createDate).toLocaleDateString()}
                  </span>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}

